import React from 'react';
import Reveal from '../ui/Reveal';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export default function FounderMirror() {
  const livedExperiences = [
    "You answer the same question again and again.",
    "Decisions wait in someone's inbox until you pick them up.",
    "Your team is capable, but nothing moves unless you are in the room.",
    "Growth is happening, but your role inside the business is becoming heavier, not lighter."
  ];

  return (
    <section id="mirror" className="py-24 md:py-32 bg-brand-cream text-brand-deep relative">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-brand-terra text-sm tracking-widest uppercase mb-6 block font-medium">The Diagnosis</span>
          <h2 className="font-serif text-4xl md:text-5xl mb-16 leading-tight">
            Your business is growing. Your team is capable. So why does everything still run through you?
          </h2>
        </Reveal>

        <div className="space-y-6 mb-20">
          {livedExperiences.map((exp, index) => (
            <Reveal key={index} delay={index * 0.1}>
              <div className="flex items-start gap-4 p-6 bg-white border border-brand-deep/5 hover:border-brand-terra/30 transition-colors duration-300">
                <SafeIcon icon={FiCheckCircle} className="text-brand-terra shrink-0 mt-1" size={20} />
                <p className="text-lg md:text-xl font-light text-brand-olive">{exp}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.4}>
          <div className="relative pl-8 md:pl-12 border-l-2 border-brand-terra py-4">
            <p className="font-serif text-2xl md:text-3xl text-brand-deep leading-relaxed">
              You are not the bottleneck because you are bad at letting go.
              <br /><br />
              <span className="text-brand-mocha">
                You are the bottleneck because no one has built the structure that lets your team move without you.
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}